import { useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardCards from '../../../../components/DashboardCard/DashboardCards';
import { VersionBreakdown } from '../VersionBreakdown';
import { getVersions } from '../../../../features';
import { useVersions } from '../../../../sections/Versions/useVersions';

import useToggle from '../../../../hooks/useToggle';

export default function VersionsCard({ more, packageList }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedPackage, setSelectedPackage] = useState('');
  const [refreshVersionBreakdown, setRefreshVersionBreakdown] = useToggle();

  const handlePackageChange = (e) => {
    setSelectedPackage(e.target.value);
  };

  const packageListData = useMemo(() => {
    return packageList
      ?.filter((item) => item.isEnabled !== false)
      .map((item) => ({
        id: item.packageId,
        name: item.packageLabel,
        value: item.packageId,
      }));
  }, [packageList]);

  useEffect(() => {
    if (packageListData?.[0]?.value) {
      setSelectedPackage(packageListData[0].value);
    }
  }, [packageListData]);

  useEffect(() => {
    if (selectedPackage) {
      dispatch(getVersions({ pkgId: selectedPackage }));
    }
  }, [refreshVersionBreakdown, selectedPackage]);

  const { versions } = useVersions();

  return (
    <DashboardCards
      title="Version Highlights"
      {...(more && {
        showButton: true,
        buttonText: 'more',
        onClick: () => navigate('/versions', { state: { more: false } }),
      })}
      packageList={packageListData}
      selectedPackage={selectedPackage}
      handlePackageChange={handlePackageChange}
    >
      <VersionBreakdown
        loading={versions?.loading}
        message="No Data"
        error={versions?.error}
        data={versions?.versionObject}
        refresh={setRefreshVersionBreakdown}
        selectedPackage={selectedPackage}
        more
      />
    </DashboardCards>
  );
}
